var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import dayjs from 'dayjs';
import { Message } from 'fbm-ui';
import Cookies from 'js-cookie';
var MAX_RETRY_COUNT = 3;
var service = axios.create({ timeout: 60000 });
var RETRIED_COUNT = 0;
var tautology = function (err) {
    var back = new Promise(function (resolve) {
        console.log('接口' + err.config.url + '请求失败，重新请求');
        RETRIED_COUNT++;
        if (RETRIED_COUNT <= MAX_RETRY_COUNT) {
            resolve(true);
        }
    });
    return back.then(function () {
        console.log(err);
        return service(err.config);
    });
};
var err = function (error) {
    if (error.response) {
        var data = error.response.data;
        console.log(data);
    }
    else {
        // 请求超时状态
        if (error.message.includes('timeout')) {
            console.log('超时了');
        }
        else {
            // 可以展示断网组件
            console.log('断网了');
        }
    }
    return Promise.reject(error);
};
var handleParams = function (config) { return __awaiter(void 0, void 0, void 0, function () {
    var avocadoConfig, cookieAccessToken, ts, _a, accessToken, expireTime, expires;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                avocadoConfig = window['AvocadoVideoInterviewConfig'];
                cookieAccessToken = Cookies.get('avocado-video-interview-access-token');
                ts = new Date().getTime();
                config.baseURL = avocadoConfig.server_url;
                return [4 /*yield*/, (cookieAccessToken ? Promise.resolve({}) : avocadoConfig.auth_callback())];
            case 1:
                _a = _b.sent(), accessToken = _a.accessToken, expireTime = _a.expireTime;
                if (accessToken) {
                    expires = expireTime ? dayjs(new Date(expireTime * 1000)).diff(new Date(), 'hour') / 24 : undefined;
                    Cookies.set('avocado-video-interview-access-token', accessToken, expires ? { expires: expires } : {});
                }
                if (avocadoConfig === null || avocadoConfig === void 0 ? void 0 : avocadoConfig.enterpriseId) {
                    config.headers['x-enterprise-id'] = avocadoConfig.enterpriseId;
                }
                config.headers['x-access-token'] = accessToken || cookieAccessToken;
                config.params ? (config.params = __assign(__assign({}, config.params), { ts: ts })) : (config.params = { ts: ts });
                return [2 /*return*/, config];
        }
    });
}); };
service.interceptors.request.use(function (config) {
    return handleParams(config);
}, err);
service.interceptors.response.use(function (response) {
    console.log(response);
    var status = response.status, _a = response.config.responseType, responseType = _a === void 0 ? '' : _a, _b = response.data, code = _b.code, message = _b.message;
    if (responseType === 'blob')
        return response;
    if (status === 200 && code === 0) {
        return response.data;
    }
    else if (status === 200 && code === -30003) {
        Cookies.remove('avocado-video-interview-access-token');
        return tautology(response);
    }
    else {
        Message.error(message);
    }
    return Promise.reject(response.data);
}, err);
export default service;
